import { getImageServerUrl } from './getConfigValues'

export function getImageUrl(url: string, width: number, height: number, crop: boolean) : string {
    if (url.indexOf('mode=crop') > 0) {
        return url;
    }
    const imageServerUrl = getImageServerUrl();
    const imageString = url.replace('https://', imageServerUrl);
    const updatedUrl = imageString.replace('.s3.amazonaws.com', '');
    return updatedUrl + '?quality=80&format=jpg&width=' + width + '&height=' + height + (crop ? 'mode=crop' : '');
}
